// extracted by mini-css-extract-plugin
export default {"nav":"HeaderNavigation_nav__sPge8","active":"HeaderNavigation_active__Yef-1"};